import { render } from "./SipsungInfoComponent.vue?vue&type=template&id=037edb78&scoped=true"
import script from "./SipsungInfoComponent.vue?vue&type=script&lang=js"
export * from "./SipsungInfoComponent.vue?vue&type=script&lang=js"

import "./SipsungInfoComponent.vue?vue&type=style&index=0&id=037edb78&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-037edb78"]])

export default __exports__